import type { EmbeddingParametersValues } from "metabase/public/lib/types";

export type ExternalProxyRuleParams = Record<
  string,
  EmbeddingParametersValues[string]
>;

export type ExternalProxyRule = {
  id?: number;
  email?: string;
  params?: ExternalProxyRuleParams;
  is_publish?: boolean;
};

export type ExternalProxyPayload = {
  resource_id: number | string;
  resource_type: "dashboard" | "question";
  report_name?: string;
  rules?: ExternalProxyRule[];
  is_published?: boolean;
  user?: unknown;
};

type ExternalProxyResponse = {
  status: boolean;
  message?: string;
  rules?: ExternalProxyRule[];
};

const apiRequest = async (
  type: "get" | "save" | "publish" | "unpublish",
  payload: ExternalProxyPayload,
) => {
  const response = await fetch("/api/jerry/extend", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      call: "post",
      service_name: "external_proxy",
      body: { type, payload },
      timeout: 120000,
    }),
  });

  const responseData = (await response.json()) as ExternalProxyResponse;
  if (!response.ok || responseData.status !== true) {
    throw new Error(responseData.message || "External proxy request failed.");
  }

  return responseData;
};

export const saveProxyConfigAPI = (payload: ExternalProxyPayload) =>
  apiRequest("save", payload);

export const getProxyConfigAPI = (payload: ExternalProxyPayload) =>
  apiRequest("get", payload);

export const publishProxyConfigAPI = (payload: ExternalProxyPayload) =>
  apiRequest("publish", payload);

export const unpublishConfigAPI = (payload: ExternalProxyPayload) =>
  apiRequest("unpublish", payload);
